import { combineEpics } from 'redux-observable';
import { forCollectionName } from './util';
import constants from '../constants';
import { actions } from '../reducers';

const eventScheduled$ = action$ =>
  action$
    .ofAction(actions.collections.pushOne)
    .filter(forCollectionName('events'))
    //.do(() => window.scrollTo(0, 0))
    .mapTo(constants.pages.SCHEDULE)
    .map(actions.pages.goToPage);

export default combineEpics(eventScheduled$);



// WEBPACK FOOTER //
// ./src/epics/pages.js